/**
 * auth接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const authEndpoints: ApiEndpoint[] = [
  {
    id: "auth-login",
    method: "POST",
    path: "/api/auth/login",
    name: "管理员登录",
    description: "管理员账号密码登录",
    category: API_CATEGORIES.AUTH,
    bodyParams: [
      { name: "account", type: "string", required: true, description: "账号" },
      { name: "password", type: "string", required: true, description: "密码" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.token", type: "string", description: "JWT Token" },
      { name: "data.user", type: "object", description: "用户信息" },
      { name: "data.permissions", type: "array", description: "权限列表" },
      { name: "data.roles", type: "array", description: "角色列表" },
    ],
    responseExample: JSON.stringify({
      success: true,
      message: "登录成功",
      data: {
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
        user: {
          id: "1",
          account: "admin",
          username: "管理员",
        },
        permissions: ["msadmin:admins:view", "msadmin:admins:create"],
        roles: ["admin"],
      },
    }, null, 2),
  },
  {
    id: "auth-verify",
    method: "POST",
    path: "/api/auth/verify",
    name: "验证Token",
    description: "验证JWT Token是否有效",
    category: API_CATEGORIES.AUTH,
    bodyParams: [
      { name: "token", type: "string", required: true, description: "JWT Token" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.valid", type: "boolean", description: "Token是否有效" },
      { name: "data.payload", type: "object", description: "Token载荷信息" },
    ],
    responseExample: JSON.stringify({
      success: true,
      message: "Token验证成功",
      data: {
        valid: true,
        payload: {
          id: "1",
          account: "admin",
          username: "管理员",
          iat: 1705747200,
          exp: 1705833600,
        },
      },
    }, null, 2),
  },
  {
    id: "auth-refresh",
    method: "POST",
    path: "/api/auth/refresh",
    name: "刷新Token",
    description: "使用刷新Token获取新的访问Token",
    category: API_CATEGORIES.AUTH,
    bodyParams: [
      { name: "refreshToken", type: "string", required: true, description: "刷新Token" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.token", type: "string", description: "新的访问Token" },
      { name: "data.refreshToken", type: "string", description: "新的刷新Token" },
    ],
  },
  {
    id: "auth-logout",
    method: "POST",
    path: "/api/auth/logout",
    name: "管理员登出",
    description: "管理员登出，清除Token",
    category: API_CATEGORIES.AUTH,
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
  },
  {
    id: "auth-current-user",
    method: "GET",
    path: "/api/auth/current-user",
    name: "获取当前用户信息",
    description: "获取当前登录用户的信息",
    category: API_CATEGORIES.AUTH,
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.user", type: "object", description: "用户信息" },
      { name: "data.permissions", type: "array", description: "权限列表" },
      { name: "data.roles", type: "array", description: "角色列表" },
    ],
  },
  {
    id: "auth-me",
    method: "GET",
    path: "/api/auth/me",
    name: "获取当前用户信息（别名）",
    description: "获取当前登录用户的信息（与 /current-user 相同）",
    category: API_CATEGORIES.AUTH,
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.user", type: "object", description: "用户信息" },
      { name: "data.permissions", type: "array", description: "权限列表" },
      { name: "data.roles", type: "array", description: "角色列表" },
    ],
  },
  {
    id: "auth-service-permissions",
    method: "POST",
    path: "/api/auth/service-permissions",
    name: "获取服务权限",
    description: "获取指定服务的权限列表",
    category: API_CATEGORIES.AUTH,
    bodyParams: [{ name: "service", type: "string", required: true, description: "服务名称" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "array", description: "权限列表" },
    ],
  },
  {
    id: "auth-verify-permission",
    method: "POST",
    path: "/api/auth/verify-permission",
    name: "验证权限",
    description: "验证用户是否具有指定权限",
    category: API_CATEGORIES.AUTH,
    bodyParams: [
      { name: "permission", type: "string", required: true, description: "权限代码" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.hasPermission", type: "boolean", description: "是否具有权限" },
    ],
  },
];
